//import storage from 'redux-persist/es/storage';
import storageSession from "redux-persist/lib/storage/session";
import { persistCombineReducers } from "redux-persist";
import { combineReducers } from "redux";
import usersReducer from "./users/usersReducer";
import timesheetsReducers from "./timesheets/timesheetsReducers";
import appUserReducer from "./appUsers/appUserReducer";
import projectsReducer from "./projects/projectsReducer";
import vacationHourReducer from "./vacationHours/vacationHourReducer";
import billingReducers from "./billing/billingReducers";
import vendorReducer from "./vendors/vendorReducer";
import ptoRequestsReducer from "./ptoRequests/ptoRequestsReducers";
import employeeRequests from "./ptoRequests/ptoRequestsReducers";

export default persistCombineReducers(
    {
        key: "root",
        storage: storageSession,
        blacklist: [
            "timesheets",
            "appUsers",
            "projects",
            "vacationHour",
            "billing",
        ],
    },
    {
        users: usersReducer,
        timesheets: timesheetsReducers,
        appUsers: appUserReducer,
        projects: projectsReducer,
        vacationHour: vacationHourReducer,
        billing: billingReducers,
        vendorsList: vendorReducer,
        ptoRequests: ptoRequestsReducer,
        employeeRequests: ptoRequestsReducer,
    }
);
